"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAILURE = exports.SUCCESS = exports.START = exports.SAGA = void 0;
var SAGA = 'apiFlow/customTableViews/loadAll/SAGA';
exports.SAGA = SAGA;
var START = 'apiFlow/customTableViews/loadAll/START';
exports.START = START;
var SUCCESS = 'apiFlow/customTableViews/loadAll/SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'apiFlow/customTableViews/loadAll/FAILURE';
exports.FAILURE = FAILURE;